import { render, staticRenderFns } from "./duplicateOrdersNew.vue?vue&type=template&id=9f6e4480&"
import script from "./duplicateOrdersNew.vue?vue&type=script&lang=js&"
export * from "./duplicateOrdersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports